class NSSOverlay extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.registerOverlay.bind(this);
    this.unregisterOverlay.bind(this);
    this.registered = Array();
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Overlay] Connected.");

    this.addEventListener("registerOverlay", this.registerOverlay, false);
    this.addEventListener("unregisterOverlay", this.unregisterOverlay, false);
    this.addEventListener("click", this.closeAll, false);
  }

  closeAll(e) {
    this.registered.forEach((tag) => {
      const element = document.querySelector(tag);
      if (element) {
        if (this.debug) console.log(`[NSS][Overlay] Asking to close:`, tag);
        const event = new CustomEvent("overlayClosed");
        element.dispatchEvent(event);
      }
      this.registered.pop(tag);
      this.updateOverlay();
    });
  }

  registerOverlay(e) {
    if (!this.registered.includes(e.detail.element)) {
      this.registered.push(e.detail.element);
      if (this.debug) console.log(`[NSS][Overlay] Registered:`, e.detail.element);
      this.style.zIndex = e.detail.zIndex;
      this.updateOverlay();
    }
  }

  unregisterOverlay(e) {
    // this.registered.splice(this.registered.indexOf(e.detail.element), 1);
    this.registered = this.registered.filter(i => i !== e.detail.element);
    if (this.debug) console.log(`[NSS][Overlay] Unregistered:`, e.detail.element);
    this.updateOverlay();
  }

  updateOverlay() {
    if (this.debug) console.log(`[NSS][Overlay] Updating overlay, this.registered:`, this.registered);
    const docEl = document.documentElement;
    if (this.registered.length > 0) {
      this.style.opacity = 1;
      this.style.pointerEvents = `all`;
      if (docEl.scrollHeight > docEl.clientHeight) {
        document.body.classList.add(`nss-no-scroll`);
        docEl.style.setProperty(`--nss-gutter-adjust`, `15px`);
      } else {
        document.body.classList.add(`nss-no-scroll-no-bar`);
      }
    } else {
      this.style.opacity = 0;
      this.style.pointerEvents = `none`;
      document.body.classList.remove(`nss-no-scroll`);
      document.body.classList.remove(`nss-no-scroll-no-bar`);
      docEl.style.setProperty(`--nss-gutter-adjust`, `0px`);
    }
  }
}

let elementName = `nss-overlay`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSOverlay);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}